export const EVENT_PLAYER_CHAPTER_CHANGE = 'vumedi:event:player:chapter-change';
